module.exports = __webpack_public_path__ + "static/software-poster-b25e89348195b0288f3aea5de3a2137c.jpg";